let noOfChar = 200; 
let contents = document.querySelectorAll('.cus-product-description');

contents.forEach(content => {
    if(content.textContent.length < noOfChar){
        document.getElementById("read-more").style.display = "none";
    }
    else {
        document.getElementById("read-more").style.display = "inline";

        let displayText  = content.textContent.slice(0, noOfChar);
        let moreText = content.textContent.slice(noOfChar);
        content.innerHTML = displayText + '<span class="dots">...</span> <span class="hide more">' + moreText + '</span>'
    }
});
 
function readMore(btn) {
    let post = document.querySelector('.product-description-wrapper'); 
    post.querySelector(".dots").classList.toggle("hide");
    post.querySelector(".more").classList.toggle("hide");
    let button = document.querySelector("#read-more")
    button.textContent == "Read more" ? button.textContent = "Read less" : button.textContent = "Read more";
}